// @ts-ignore
import dayjs from 'dayjs';
export function Format (date: string) {
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
}
export function FormatAddOne (date: string) {
  return dayjs(date).format('YYYY-MM-DD');
}
